import { render, staticRenderFns } from "./dealer-steps.vue?vue&type=template&id=59e20140&scoped=true&"
import script from "./dealer-steps.vue?vue&type=script&lang=js&"
export * from "./dealer-steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e20140",
  null
  
)

export default component.exports